import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import {
  ATTACHMENT_TABS_IDENTIFIER,
  ATTACHMENT_LIST_IDENTIFIER,
  CALL_STATE_IDENTIFIER,
} from "./constants";

const emptyState = {
  [ATTACHMENT_TABS_IDENTIFIER]: [],
  [ATTACHMENT_LIST_IDENTIFIER]: null,
  [CALL_STATE_IDENTIFIER]: IResponseState.PENDING,
};

export default emptyState;
